import React, { useEffect, useState } from "react";
import { View, ScrollView, TouchableOpacity } from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import FormattedText, { formatValue } from "../../../components/FormattedText";
import { Linking } from "react-native";
import commonStyles from "../../../styles/commonStyles";
import OverflowTooltipText from "../../../components/OverflowTooltipText";
import {
  IEntityPropertyModel,
  IPropertyData,
} from "../../../types/IPropertyDataType";
import { formatDate } from "../../../common/utils";
import { mapPropertyStatus } from "../../../common/enums/PropertyStatus";
import { SafeAreaView } from "react-native-safe-area-context";
import { ApiService } from "../../../service/ApiService";
import SkeletonLoader from "../../../components/SkeletonLoader";
import { isLoading } from "expo-font";
import AppText from "../../../components/AppText";

type PropertyDetailsProps = {
  navigation: NativeStackNavigationProp<any>;
  route: {
    params: {
      property: any;
      shareholderName: string;
      isInvestment: boolean;
      sourcePage?: string;
    };
  };
};

const PropertyDetails: React.FC<PropertyDetailsProps> = ({
  navigation,
  route,
}) => {
  const { property } = route.params;
  const { isInvestment } = route.params;
  const { shareholderName } = route.params;
  const [propertyData, setPropertyData] = useState<IPropertyData>(property);
  const [loading, setLoading] = useState(true);

  const roundToTwoDecimals = (value: number): number => {
    return Math.round(value * 100) / 100;
  };

  console.log("the invesl.. ", isInvestment);
  console.log("the property data is", property);

  useEffect(() => {
    if (isInvestment) {
      fetchPropertyData();
    } else {
      setLoading(false);
    }
  }, [isInvestment]);

  const openLink = async (url: string) => {
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    } else {
      console.log("Don't know how to open URI: " + url);
    }
  };

  const fetchPropertyData = async () => {
    try {
      const response = await ApiService.get<IPropertyData>(
        `portal/property/${property.propertyId}`,
      );

      const item = response.data;
      item.entityName = property.entityName;
      item.totalAcres = property.totalAcres;
      item.yourAcres =
        (property.totalAcres * property.shareholderOwnership) / 100;

      item.remainingAcres =
        (item.remainingAcres * property.shareholderOwnership) / 100;

      const roundedAcres = roundToTwoDecimals(item.remainingAcres);
      const roundedPrice = roundToTwoDecimals(item.potentialPricePerAcres);

      item.potentialMarketValue = roundToTwoDecimals(
        roundedAcres * roundedPrice,
      );
      setPropertyData(item);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching property:", error);
      setLoading(false);
    }
  };
  return (
    <SafeAreaView
      edges={["bottom", "left", "right"]}
      style={[commonStyles.flex1, commonStyles.screenBottomGap]}
    >
      <View style={commonStyles.container}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={commonStyles.subHeaderContainer}
        >
          <AntDesign testID="back-arrow" name="left" size={24} color="black" />
          <OverflowTooltipText
            testID="property-name-value"
            text={propertyData.name}
            style={commonStyles.subHeader}
            onPress={() => navigation.goBack()}
          />
        </TouchableOpacity>
        {loading ? (
          <View>
            <SkeletonLoader rows={10} rowWidth="100%" />
          </View>
        ) : (
          <ScrollView testID="scrollView">
            <View
              style={[
                commonStyles.subContainer,
                commonStyles.p14,
                commonStyles.mlar2,
                commonStyles.mt5,
                commonStyles.pt0,
                commonStyles.mb10,
              ]}
            >
              <View style={commonStyles.columnContainer}>
                <AppText testID="entity-name" style={commonStyles.sectionLabel}>
                  Entity Name
                </AppText>
                <View style={{ width: "100%", alignItems: "flex-end" }}>
                  <OverflowTooltipText
                    testID="entity-name-value"
                    text={propertyData.entityName}
                    style={commonStyles.valueText}
                    //containerWidth="58%"
                  />
                  {/* <AppText
                    testID="entity-name-value"
                    style={commonStyles.valueText}
                  >
                    {propertyData.entityName}
                  </AppText> */}
                </View>
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="status" style={commonStyles.subTitle}>
                  Status
                </AppText>
                <AppText testID="status-value" style={commonStyles.subValue}>
                  {mapPropertyStatus(propertyData.status)}
                </AppText>
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="total-acres" style={commonStyles.subTitle}>
                  Total Acres
                </AppText>
                <FormattedText
                  testID="total-acres-value"
                  value={propertyData.totalAcres}
                  type="number"
                  style={commonStyles.subValue}
                />
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="sold-acres" style={commonStyles.subTitle}>
                  Sold Acres
                </AppText>
                <FormattedText
                  testID="sold-acres-value"
                  value={propertyData.soldAcres}
                  type="number"
                    containerWidth="50%"

                  tooltip={true}
                  tooltipValue={`${propertyData.shareholderName || shareholderName} has sold ${formatValue(
                    propertyData.soldAcres,
                    "number",
                  )} undivided acres from the ${propertyData.name} property`}
                  style={commonStyles.subValue}
                />
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="your-acres" style={commonStyles.subTitle}>
                  Your Original Acres
                </AppText>
                <FormattedText
                  testID="your-acres-value"
                  tooltip={true}
                  value={propertyData.yourAcres}
                  type="number"
                  containerWidth="50%"
                  tooltipValue={`${propertyData.shareholderName || shareholderName} originally owned ${formatValue(
                    propertyData.yourAcres,
                    "number",
                  )} undivided acres in ${
                    propertyData.name
                  } before any acres were sold`}
                  style={commonStyles.subValue}
                />
              </View>

              {propertyData.remainingAcres != propertyData.totalAcres &&
              propertyData.remainingAcres != propertyData.yourAcres ? (
                <View style={commonStyles.subDetails}>
                  <AppText
                    testID="remaining-acres"
                    style={[commonStyles.subTitle]}
                  >
                    Your Remaining Acres
                  </AppText>
                  <FormattedText
                    testID="remaining-acres-value"
                    value={propertyData.remainingAcres}
                    type="number"
                    tooltip={true}
                    containerWidth="50%"
                    tooltipValue={`${propertyData.shareholderName || shareholderName} currently own ${formatValue(
                      propertyData.remainingAcres,
                      "number",
                    )} undivided acres from the ${propertyData.name} property`}
                    style={commonStyles.subValue}
                  />
                </View>
              ) : (
                ""
              )}
              <View style={commonStyles.subDetails}>
                <AppText testID="google-location" style={commonStyles.subTitle}>
                  Google Location
                </AppText>
                {propertyData.googleMapLocation ? (
                  <AppText
                    testID="google-location-value"
                    style={commonStyles.link}
                    onPress={() => openLink(propertyData.googleMapLocation)}
                  >
                    view
                  </AppText>
                ) : (
                  <AppText
                    testID="google-location-no-value"
                    style={commonStyles.subValue}
                  >
                    N/A
                  </AppText>
                )}
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="google-earth" style={commonStyles.subTitle}>
                  Google Earth
                </AppText>
                {propertyData.googleEarthLocation ? (
                  <AppText
                    testID="google-earth-value"
                    style={commonStyles.link}
                    onPress={() => openLink(propertyData.googleEarthLocation)}
                  >
                    view
                  </AppText>
                ) : (
                  <AppText
                    testID="google-earth-no-value"
                    style={commonStyles.subValue}
                  >
                    N/A
                  </AppText>
                )}
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="land-id" style={commonStyles.subTitle}>
                  Land Id
                </AppText>
                {propertyData.googleEarthLocation ? (
                  <AppText
                    testID="land-id-value"
                    style={commonStyles.link}
                    onPress={() => openLink(propertyData.googleEarthLocation)}
                  >
                    view
                  </AppText>
                ) : (
                  <AppText
                    testID="land-id-no-value"
                    style={commonStyles.subValue}
                  >
                    N/A
                  </AppText>
                )}
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="documents" style={commonStyles.subTitle}>
                  Documents
                </AppText>
                {propertyData.documentsURL ? (
                  <AppText
                    testID="documents-value"
                    style={commonStyles.link}
                    onPress={() => openLink(propertyData.documentsURL)}
                  >
                    view
                  </AppText>
                ) : (
                  <AppText
                    testID="documents-no-value"
                    style={commonStyles.subValue}
                  >
                    N/A
                  </AppText>
                )}
              </View>

              <View style={commonStyles.subDetails}>
                <OverflowTooltipText
                  testID="purchase-date"
                  text="Purchase Date"
                  style={commonStyles.subTitle}
                  containerWidth="60%"
                />
                <AppText
                  testID="purchase-date-value"
                  style={commonStyles.subValue}
                >
                  {formatDate(propertyData.closingDate)}
                </AppText>
              </View>
              <View style={commonStyles.subDetails}>
                <OverflowTooltipText
                  testID="purchase-price"
                  text="Purchase Price"
                  style={commonStyles.subTitle}
                  containerWidth="50%"
                />
                <FormattedText
                  testID="purchase-price-value"
                  value={propertyData.price}
                  type="currency"
                  style={commonStyles.subValue}
                />
              </View>
              <View style={commonStyles.subDetails}>
                <AppText testID="price-acre" style={commonStyles.subTitle}>
                  Price/Acre
                </AppText>
                <FormattedText
                  testID="price-acre-value"
                  value={propertyData.pricePerAcre}
                  type="currency"
                  style={commonStyles.subValue}
                />
              </View>
              <View style={commonStyles.subDetails}>
                <OverflowTooltipText
                  testID="potential-price-acre"
                  text="Potential Price/Acre"
                  style={commonStyles.subTitle}
                  containerWidth="60%"
                />
                <FormattedText
                  testID="potential-price-acre-value"
                  value={propertyData.potentialPricePerAcres}
                  type="currency"
                  style={commonStyles.subValue}
                />
              </View>
              <View style={commonStyles.subDetails}>
                <OverflowTooltipText
                  testID="potential-market"
                  text="Potential Market Value"
                  style={commonStyles.subTitle}
                  containerWidth="60%"
                />
                <FormattedText
                  testID="potential-market-value"
                  value={propertyData.potentialMarketValue}
                  type="currency"
                  style={commonStyles.subValue}
                />
              </View>
            </View>
          </ScrollView>
        )}
      </View>
    </SafeAreaView>
  );
};

export default PropertyDetails;
